import React from "react";

export type FlagProps = {
    alt: string;
    countryCode: string;
    width?: number;
    height?: number;
};

export const DEFAULT_CDN_URL = "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/";

const DEFAULT_FLAG_WIDTH = 32;
const DEFAULT_FLAG_HEIGHT = 24;

export const Flag = ({
    alt,
    countryCode,
    width = DEFAULT_FLAG_WIDTH,
    height = DEFAULT_FLAG_HEIGHT,
}: FlagProps) => {
    return (
        <img
            alt={alt}
            src={`${DEFAULT_CDN_URL}${countryCode.toLowerCase()}.svg`}
            style={{
                width,
                height,
                objectFit: "cover",
                border: "solid",
                borderWidth: "2px",
                borderColor: "white",
                borderRadius: "4px",
            }}
        />
    );
};
